<template>
    <div class="panel panel-default panel-dashboard">
        <loading-spinner v-if="loading"/>

        <div v-else class="panel-body">
            <div class="tw-h-8 tw-bg-green-200 tw-rounded-full">
                <div
                    class="tw-h-8 tw-rounded-full tw-bg-green-600"
                    :style="{'width': Math.min(totalScore / competition.attributes.shared_target * 100, 100)+ '%'}"
                />
            </div>

            <div class="tw-text-center tw-py-4">
                <span class="tw-text-4xl tw-font-bold">
                    {{ getFormattedScore(totalScore) }} / {{ getFormattedScore(competition.attributes.shared_target) }}
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import http from '@/http'
import store from '@/store'
import LoadingSpinner from '@/components/Layout/LoadingSpinner'

export default {
    components: {LoadingSpinner},

    props: {
        competition: {
            required: true
        }
    },

    data() {
        return {
            participations: null,

            loading: true,
            shared: store
        }
    },

    mounted() {
        this.load()
    },

    watch: {
        competition() {
            this.load()
        }
    },

    computed: {
        totalScore() {
            return this.participations.reduce((sum, participation) => sum + participation.attributes.score, 0)
        }
    },

    methods: {
        load() {
            this.loading = true

            http.get('/api/v2/competitions/' + this.competition.id + '/participations')
                .then(response => {
                    this.participations = response.data.data

                    this.loading = false
                })
        },

        getFormattedScore(value) {
            if (this.competition.attributes.score_unit === 'number') {
                return this.$options.filters.number(value)
            }

            if (this.competition.attributes.score_unit === 'money') {
                return this.$options.filters.price(value)
            }

            if (this.competition.attributes.score_unit === 'stars') {
                return '⭐ ' + value
            }

            return value
        }
    }
}
</script>
